// Dates de l'Open, affichées sur l'accueil et l'agenda.
// La date de référence pour la validité des licences est dans Back/config.json.
export const NEXT_OPEN_DATES = "20 et 21 février 2027";
export const LAST_OPEN_DATES = "21 et 22 février 2026";
